import React, { useEffect, useRef, useState } from 'react';

const useIntersectionObserver = (
  deps: React.DependencyList = [],
  options: IntersectionObserverInit = {},
): {
  containerRef: React.Ref<any>,
  entry: IntersectionObserverEntry | null,
  isIntersected: boolean,
} => {
  const [entry, setEntry] = useState<IntersectionObserverEntry | null>(null);
  const [isIntersected, setIsIntersected] = useState(false);

  const containerRef = useRef<Element | null>(null);
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
      setIsIntersected(false);
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new window.IntersectionObserver(([entry]) => setEntry(entry), options);
      const { current: currentObserver } = observer;
      if (containerRef.current) {
        currentObserver.observe(containerRef.current);
      }

      return () => currentObserver.disconnect();
    },
    deps,
  );

  useEffect(() => {
    if (entry?.isIntersecting) {
      setIsIntersected(true);
    }
  }, [entry]);

  return {
    containerRef,
    entry,
    isIntersected,
  };
};

export default useIntersectionObserver;
